import { RequestTypeValueEnum } from '@app/generated-api';

export enum LiveNotificationsActionEnum {
    Created = 'Created',
    Updated = 'Updated',
    Deleted = 'Deleted',
}

// mirrors Medpace.PCS.Business.v2.Models.LiveNotifications.Request.RequestChangedNotification
export interface RequestChangedNotification {
    requestType: RequestTypeValueEnum;
    id: number;
    action: LiveNotificationsActionEnum;
}
